import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { renderToStaticMarkup } from "react-dom/server";

import Storage from "react-native-storage";
import i18n from "i18n-react";

// FontAwesome
import "config/FontAwesome";

import {
  AppSettings,
  APIHandler,
  AppRouter,
  DataHandler,
  locales,
  StorageHandler,
  MobileWarning,
  CookieWarning,
  SweetAlert,
} from "C4";
import { storageKeys, language, userKeys } from "settings";

import "normalize.css/normalize.css";
import "./assets/styles/styles.scss";

const { cookieEnabled } = window.navigator;

const exportObject = cookieEnabled
  ? new Storage({
      storageBackend: cookieEnabled ? window.localStorage : {},
      defaultExpires: 1000 * 3600 * 24, // 1 day = (1000 * 3600 * 24 milliseconds), null = never expire
      enableCache: true,
      sync: {
        // TODO: Handle exiration of data (Reload data with new API Calls)
      },
    })
  : {};

export default exportObject;

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load
const params = new URLSearchParams(window.location.search);
if (params.get("lang")) {
  i18n.setTexts(locales[params.get("lang")]);
}

// UTM Source for form submission
if (params.get("utm_source")) {
  StorageHandler.save(storageKeys.utmSource, params.get("utm_source"));
}

if (params.get("utm_medium")) {
  StorageHandler.save(storageKeys.utmMedium, params.get("utm_medium"));
}

if (params.get("utm_campaign")) {
  StorageHandler.save(storageKeys.utmCampaign, params.get("utm_campaign"));
}

const availableLanguages = language
  .map(({ code }) =>
    typeof code === "string" ? code : code.map((c) => c.toLowerCase())
  )
  .flat();
const commitRisk = language.some(
  (lang) => lang.id === 220 && lang.countries.length > 0
);
if (commitRisk) {
  console.error(
    "One of the testing languages is currently in use. Please remove before committing."
  );
}

DataHandler.matchAppId().then((appId) => {
  StorageHandler.load(storageKeys.appId).then((id) => {
    if (id !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter((key) => {
          const k = storageKeys[key];
          return k !== storageKeys.appId && k !== storageKeys.lang;
        })
      );
      StorageHandler.save(storageKeys.appId, appId);
    } else {
      StorageHandler.save(storageKeys.appId, id);
    }
    StorageHandler.load(storageKeys.lang).then((lang) => {
      i18n.setTexts(locales[lang.langFile]);
    });
    if (sessionStorage.getItem(sessionStorage.key("tt_sessionId")) !== "-1") {
      StorageHandler.load(storageKeys.user).then((res) => {
        if (res) {
          const { email } = res;
          APIHandler.lastActive(appId, email);
          sessionStorage.setItem(sessionStorage.key("tt_sessionId"), -1);
        }
      });
    }
  });
  window.appId = appId;
});

if (cookieEnabled) {
  // Check if language is already set, proceed said language.
  StorageHandler.exists(storageKeys.lang).then((languageExists) => {
    if (languageExists) {
      if (params.get("lang")) {
        let newLanguageCode = params.get("lang").toLowerCase();
        if (newLanguageCode === "undefined") {
          newLanguageCode = "en";
        }
        const newCountry = language.filter(
          (langSettings) => langSettings.langFile === newLanguageCode
        )[0].countries[0];
        StorageHandler.save(storageKeys.lang, {
          country: newCountry,
          code: newLanguageCode.toUpperCase(),
          langFile: newLanguageCode,
        });
        i18n.setTexts(locales[params.get("lang")]);
      } else {
        StorageHandler.load(storageKeys.lang).then((lang) => {
          i18n.setTexts(locales[lang.langFile]);
        });
      }
    } else if (params.get("lang")) {
      let newLanguageCode = params.get("lang").toLowerCase();
      if (newLanguageCode === "undefined") {
        newLanguageCode = "en";
      }

      const newCountry = language.filter(
        (langSettings) => langSettings.langFile === newLanguageCode
      )[0].countries[0];
      StorageHandler.save(storageKeys.lang, {
        country: newCountry,
        code: newLanguageCode.toUpperCase(),
        langFile: newLanguageCode,
      });
      window.location.reload();
    } else {
      const browserLanguage =
        window.navigator.language || window.navigator.userLanguage;
      if (availableLanguages.includes(browserLanguage)) {
        const newCountry = language.filter(
          (langSettings) => langSettings.langFile === browserLanguage
        )[0].countries[0];
        StorageHandler.save(storageKeys.lang, {
          country: newCountry,
          code: browserLanguage.toUpperCase(),
          langFile: browserLanguage,
        });
        i18n.setTexts(locales[browserLanguage]);
      } else {
        StorageHandler.save(storageKeys.lang, {
          country: "English",
          code: "en",
          langFile: "en",
        });
        i18n.setTexts(locales.en);
      }
      window.location.reload();
    }
  });

  StorageHandler.load("askedMobile").then((askedBefore) => {
    ReactDOM.render(
      <App askedBefore={askedBefore} />,
      document.getElementById("root")
    );
  });
}

class App extends Component {
  constructor(props) {
    super(props);

    const mobileRegex = new RegExp(
      "Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini",
      "i"
    );
    const mobilePathRegex = new RegExp("mobile", "i");

    this.state = {
      onMobile:
        mobileRegex.test(window.navigator.userAgent) &&
        !mobilePathRegex.test(window.location.href),
      askedBefore: null,
      appLanguage: null,
      appId: null,
    };
  }

  componentDidMount() {
    this.setLanguage();
    this.getAppId();
    this.setLoader();
  }

  componentDidUpdate() {
    const { appLanguage } = this.state;
    const { texts } = i18n;

    if (JSON.stringify(appLanguage) !== JSON.stringify(texts)) {
      i18n.setTexts(appLanguage);
    }
  }

  async getAppId() {
    const appId = await DataHandler.matchAppId();
    const localId = await StorageHandler.load(storageKeys.appId);

    if (localId !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter(
          (key) =>
            ![storageKeys.appId, storageKeys.lang].includes(storageKeys[key])
        )
      );
    }

    StorageHandler.save(storageKeys.appId, appId, 86400000 * 365);
    this.setState({ appId });

    window.appId = appId;
  }

  async getLocation() {
    const { countryCode, country } = (await APIHandler.getLocation()) || {};
    const languageData = {
      country: "English",
      code: "en",
      langFile: "en",
    };

    const availableLanguage = language
      .map(({ code }) =>
        typeof code === "string" ? code : code.map((c) => c.toLowerCase())
      )
      .flat();
    if (countryCode) {
      Object.assign(languageData, {
        country: "English",
        code: countryCode,
        langFile: "en",
      });
    }

    if (
      countryCode &&
      country &&
      availableLanguage.includes(countryCode.toLowerCase())
    ) {
      const [file] = language
        .filter(({ code }) =>
          typeof code === "string" ? code === countryCode : code.includes(code)
        )
        .map(({ langFile }) => langFile);

      Object.assign(languageData, {
        country: country.replace(/[ ]/g, "_"),
        code: countryCode.toLowerCase(),
        langFile: file,
      });
    }
    StorageHandler.save(storageKeys.lang, languageData);
    this.setState({
      appLanguage: locales[languageData.langFile] || locales.en,
    });
  }

  async setLanguage() {
    const languageExists = await StorageHandler.exists(storageKeys.lang);
    if (languageExists) {
      const { langFile } = (await StorageHandler.load(storageKeys.lang)) || {};
      this.setState({ appLanguage: locales[langFile] || locales.en });
    } else {
      this.getLocation();
    }
  }

  setLoader() {
    AppSettings().then((res) => {
      if (res) {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { onMobile } = this.state;
    const params = new URLSearchParams(window.location.search);
    let header = true;
    if (params.get("header") === "false") {
      header = false;
    }

    return (
      <div className="container__router">
        {!cookieEnabled && <CookieWarning />}
        <AppRouter />
        {header && onMobile && <MobileWarning />}
      </div>
    );
  }
}
